import(/* webpackMode: "eager" */ "D:\\GIT\\learn-frontend\\app\\contexts\\AuthProvider.tsx")